import { ProcessInputField } from './process-input-field.model';

export class ConnectionAction {
    action: 'href' | 'conn_create_process' = 'href';
    url?: string;
    inputs?: ProcessInputField[];

    deserialize(data: any): this {
        this.action = data.action ?? 'href';
        this.url = data.url;
        this.inputs = data.inputs != null ? data.inputs.map((input: any) => new ProcessInputField().deserialize(input)) : undefined;

        return this;
    }
}
